/**
 * Shoppable Banner Section JS
 */
if (!window.__shoppableAddToCartInitialized) {
  window.__shoppableAddToCartInitialized = true;

  /* Handle product card click on mobile (<= 991px) to open Quick Add Modal */
  document.addEventListener('click', function (e) {
    var productCard = e.target.closest('.shoppable-banner__product-card');
    if (!productCard) return;

    if (window.innerWidth <= 991 && typeof openQuickAddModal === 'function') {
      e.preventDefault();
      var item = productCard.closest('.shoppable-banner__product-item');
      if (!item) return;

      var popupTitle = item.querySelector('.shoppable-banner__popup-title a');
      var popupPrice = item.querySelector('.shoppable-banner__popup-price');
      var popupVariant = item.querySelector('.shoppable-banner__popup-variant');
      var popupAddBtn = item.querySelector('.js-shoppable-add-to-cart');
      var imgEl = item.querySelector('.shoppable-banner__product-img');

      var productUrl = productCard.dataset.productUrl || (item ? item.dataset.productUrl : '') || (popupTitle ? popupTitle.getAttribute('href') : '') || productCard.getAttribute('href') || '#';
      var productHandle = productCard.dataset.productHandle || (item ? item.dataset.productHandle : '') || (typeof getProductHandleFromUrl === 'function' ? getProductHandleFromUrl(productUrl) : '');
      var productId = productCard.dataset.productId || (item ? item.dataset.productId : null);

      openQuickAddModal({
        trigger: 'shoppable-banner',
        triggerEl: productCard,
        variantId: popupAddBtn ? popupAddBtn.dataset.variantId : '',
        productId: productId,
        handle: productHandle,
        productHandle: productHandle,
        title: popupTitle ? popupTitle.textContent.trim() : '',
        price: popupPrice ? popupPrice.innerHTML.trim() : '',
        variant: popupVariant ? popupVariant.textContent.trim() : '',
        image: imgEl ? imgEl.src : '',
        url: productUrl,
        available: popupAddBtn ? !popupAddBtn.disabled : true
      });
    }
  });

  /* Desktop Add to Cart button inside hover popup card */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.js-shoppable-add-to-cart');
    if (!addBtn) return;

    e.preventDefault();
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        if (typeof refreshCart === 'function') {
          refreshCart();
        }
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(function (err) {
        console.error('Error adding product to cart:', err);
      })
      .finally(function () {
        addBtn.disabled = false;
      });
  });
}
